module.exports = __webpack_public_path__ + "img/yahoo.cd803346.png";